import {Notification,type NotificationData} from "@/types/site_configuration/notification";

export class Department {
    public id: number | null;
    public name: string;
    public description: string;
    public notifications: Notification[] | undefined;

    constructor(data: DepartmentData | void) {
        if (data === undefined) {
            this.id = null;
            this.name = "";
            this.description = "";
            this.notifications = [];

        } else {
            this.id = data.id;
            this.name = data.name;
            this.description = data.description;
            this.notifications = [];

            if (data.notifications !== undefined) {
                data.notifications.forEach(notification => this.notifications.push((new Notification(notification))));
            }
        }
    }

    serializeData(without_relations: boolean | Array<string> = false, with_relations: boolean | Array<string> = false, ids_only:boolean = false) {

        const serialized_data = {
            id: this.id,
            name: this.name,
            description: this.description,
        }

        return serialized_data;
    }

}

export type DepartmentData = {
    id: number | null;
    name: string;
    description: string;
    notifications: NotificationData[] | undefined;

}